var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "px-2 my-2",
      staticStyle: { "flex-wrap": "nowrap" },
      attrs: { cols: "12", xl: "6", lg: "4", md: "4", sm: "12" },
    },
    [
      _c(
        "v-card",
        {
          staticStyle: { height: "inherit", padding: "4px" },
          attrs: { loading: _vm.loading },
        },
        [
          _c(
            "v-list-item",
            {
              class: _vm.selected ? "selected" : "",
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.handleSelectionClick },
            },
            [
              _vm._t("avatar", function () {
                return [
                  _c(
                    "v-list-item-avatar",
                    { attrs: { size: "64px" } },
                    [
                      _vm._t("avatar", function () {
                        return [
                          _c("v-img", {
                            attrs: { height: "100%", src: _vm.previewImage },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              }),
              _c(
                "v-list-item-content",
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-row",
                        {
                          staticStyle: {
                            "align-items": "center",
                            "flex-wrap": "wrap",
                            height: "64px",
                          },
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticStyle: { "vertical-align": "middle" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("p", { staticClass: "ma-0" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.course.CourseTitle) + " "
                                ),
                              ]),
                            ]
                          ),
                          _vm.course.booked
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ml-1",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("Tag", {
                                    attrs: {
                                      tagCount: 1,
                                      tagInfo: _vm.tagBooked,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.course.payed
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ml-1",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("Tag", {
                                    attrs: {
                                      tagCount: 1,
                                      tagInfo: _vm.tagPayed,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.course.reserved
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ml-1",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("Tag", {
                                    attrs: {
                                      tagCount: 1,
                                      tagInfo: _vm.tagReserved,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-subtitle",
                    { staticClass: "my-2", staticStyle: { height: "120px" } },
                    [
                      _c("div", { staticClass: "listitem-info-container" }, [
                        _c(
                          "div",
                          { staticClass: "info-icon" },
                          [_c("v-icon", [_vm._v("mdi-calendar-range")])],
                          1
                        ),
                        _c("div", {
                          staticClass: "info-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFancyDatestring(
                                _vm.course.CourseStartDate,
                                _vm.course.CourseEndDate
                              )
                            ),
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "listitem-info-container" }, [
                        _c(
                          "div",
                          { staticClass: "info-icon" },
                          [_c("v-icon", [_vm._v("mdi-currency-eur")])],
                          1
                        ),
                        _c("div", { staticClass: "info-content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$n(
                                _vm.course.RegularPrice,
                                "currency",
                                "de-DE"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "listitem-info-container" }, [
                        _c(
                          "div",
                          { staticClass: "info-icon" },
                          [_c("v-icon", [_vm._v("mdi-account-multiple")])],
                          1
                        ),
                        _c("div", { staticClass: "info-content" }, [
                          _vm._v(_vm._s(_vm.courseParticipants)),
                        ]),
                      ]),
                      !_vm.isNoWs(_vm.course.CourseDesignation)
                        ? _c(
                            "div",
                            { staticClass: "listitem-info-container" },
                            [
                              _c(
                                "div",
                                { staticClass: "info-icon" },
                                [_c("v-icon", [_vm._v("mdi-text")])],
                                1
                              ),
                              _c("div", { staticClass: "info-content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.stripHtml(_vm.course.CourseDesignation)
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.course.IsCourseClubOnly
                        ? _c(
                            "div",
                            { staticClass: "listitem-info-container" },
                            [
                              _c(
                                "div",
                                { staticClass: "info-icon" },
                                [_c("v-icon", [_vm._v("mdi-lock")])],
                                1
                              ),
                              _c("div", { staticClass: "info-content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("overview.preview_info_clubInternal")
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "v-row",
            { staticClass: "mt-1 px-4", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-slide-group",
                { attrs: { "show-arrows": "" } },
                _vm._l(_vm.course.tags, function (tag, index) {
                  return _c("Tag", {
                    key: "tag_coursePrev" + _vm.course.CourseId + "_" + index,
                    attrs: { tagCount: _vm.course.tags.length, tagInfo: tag },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }